import { createSlice } from '@reduxjs/toolkit'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'
import { BizChannelTypes } from '../../../Codes'

export const showCreativePreview = createAxiosThunk(
  'dashboard/creativePreview/showCreativePreview',
  async creativeId => {
    const {
      data: { creative },
    } = await api.creative.getCreative(creativeId)
    const { data: channel } = await api.ad.getBizChannel(creative.bizChannelId)
    return api.response({
      channel,
      creative,
    })
  }
)

const creativePreviewSlice = createSlice({
  name: 'dashboard/creativePreview',

  initialState: {
    isLoading: false,
    isShowPreview: false,
    channel: {
      bizChannelType: BizChannelTypes.WEBSITE_BIZ_CHANNEL,
      name: undefined,
      siteUrl: null,
    },
    creative: {
      assets: [],
    },
  },

  reducers: {
    hideCreativePreview: state => {
      state.isShowPreview = false
    },
  },

  extraReducers: builder => {
    builder.addCase(showCreativePreview.pending, state => {
      state.isLoading = true
      state.isShowPreview = true
    })

    builder.addCase(
      showCreativePreview.fulfilled,
      (state, { payload: { channel, creative } }) => {
        state.channel = channel
        state.creative = creative
        state.isLoading = false
      }
    )

    builder.addCase(showCreativePreview.rejected, state => {
      state.isLoading = false
    })
  },
})

const { actions, reducer } = creativePreviewSlice
export const { hideCreativePreview } = actions
export default reducer
